export default "__VITE_ASSET__BogUNOPQ__"